import { PaymentSystemListFilter, PaymentSystemListItem } from '@/models/dictionary/payment-system-list.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface PaymentSystemListState {
  paymentSystemList: PaymentSystemListItem[];
  isPaymentSystemListLoading: boolean;
}

export const usePaymentSystemListStore = defineStore({
  id: 'PaymentSystemListStore',
  state: (): PaymentSystemListState => ({
    paymentSystemList: [],
    isPaymentSystemListLoading: false,
  }),
  getters: {
    uniquePaymentSystemList: (state: PaymentSystemListState): PaymentSystemListItem[] => {
      return Array.from(
        new Map(state.paymentSystemList.map((item: PaymentSystemListItem) => [item.paymentSystem, item])).values(),
      );
    },
  },
  actions: {
    setPaymentSystemListLoading(isLoading: boolean): void {
      this.isPaymentSystemListLoading = isLoading;
    },
    getPaymentSystemList(filterList?: PaymentSystemListFilter): Promise<PaymentSystemListItem[] | void> {
      this.setPaymentSystemListLoading(true);

      return api.dictionary.getPaymentSystemListRequest.perform({ filterList })
        .then((data) => {
          this.paymentSystemList = data;
        })
        .catch(error => {
          showErrorNotification(error);

          return Promise.reject(error);
        })
        .finally(() => {
          this.setPaymentSystemListLoading(false);
        });
    },
  },
});
